import { FormulaireConnexionHl } from "../../components/formulaire/formulaireConnexionHl";
import { FormulaireConnexionUser } from "../../components/formulaire/formulaireConnexionUser"
import { useConf } from "../../context/account/paramsAccount";
export function Connexion() {
    const { conf }: any = useConf()
    return (
        <div>
            {conf?.conf?.ifOffLineMode !== true ?
                <FormulaireConnexionUser></FormulaireConnexionUser>
                : <FormulaireConnexionHl></FormulaireConnexionHl>
            }
        </div>
    )
}